import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {PricingModal} from "../../../app/components/pricing-modal/pricing-modal.component";
import {Events, ModalController} from "ionic-angular";
import {JobTimeModal} from "../../../app/components/job-time-modal/job-time-modal.component";
import {Job} from "../shared/job.model";
import {PlacesSearchModal} from "../../../app/components/places-search-modal/places-search-modal.component";
import {JobService} from "../shared/job.service";
import {ToastService} from "../../../app/core/toast.service";

@Component({
  selector: 'app-interpreter-job-details',
  templateUrl: 'interpreter-job-details.component.html',

})
export class InterpreterJobDetailsComponent implements OnInit, OnDestroy {
  @Input('job') job: Job;

  constructor(
    private modalCtrl: ModalController,
    private jobService: JobService,
    private toast: ToastService,
    private events: Events
  ){
  }

  ngOnInit(){
    this.events.subscribe('place:selected', (place) => this.updateAddress(place));
  }

  ngOnDestroy(){
    this.events.unsubscribe('place:selected');
  }

  updateAddress(place) {
    if (place.hasOwnProperty('formatted_address')) {
      this.job.address = place.formatted_address;
      this.job.latitude = place.geometry.location.lat();
      this.job.longitude = place.geometry.location.lng();
      this.jobService.updateAddress(this.job)
        .subscribe(
          (res) => {
            this.toast.show(res.message);
            this.events.publish('job:updated');
          }
        );
    }
  }

  showPricingModal() {
    let modal = this.modalCtrl.create(PricingModal);
    modal.present();
  }

  showJobTimeModal() {
    let modal = this.modalCtrl.create(JobTimeModal, {
      job: this.job
    });
    modal.present();
  }

  showJobLocationModal() {
    let modal = this.modalCtrl.create(PlacesSearchModal);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/interpreter-job-details/interpreter-job-details.component.ts